<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-card-title>Document</b-card-title>
        <b-table :items="items" :fields="fields" striped responsive>
          <template #cell(view_document)="row">
            <b-form-checkbox
              v-model="row.detailsShowing"
              plain
              class="vs-checkbox-con"
              @change="row.toggleDetails"
            >
              <span class="vs-checkbox"> </span>
              <span class="vs-label">{{
                row.detailsShowing ? "Hide" : "Show"
              }}</span>
            </b-form-checkbox>
          </template>

          <template #row-details="row">
            <b-row class="mb-2">
              <b-col md="3" class="mb-1">
                <b-form-file
                  ref="fileInput"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  multiple
                  class="d-none"
                  @change="handleFileUpload"
                />
                <b-button variant="primary" @click="openFilePicker"
                  >Upload Document</b-button
                >
              </b-col>
            </b-row>

            <b-row>
              <b-col md="3">
                <b-card class="custom-card mb-5">
                  <b-card-header class="justify-content-end px-0">
                    <b-dropdown
                      variant="link"
                      no-caret
                      class="chart-dropdown"
                      toggle-class="p-0"
                    >
                      <template #button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="18"
                          class="text-body cursor-pointer"
                        />
                      </template>
                      <b-dropdown-item v-b-modal.modal-document>
                        View
                      </b-dropdown-item>
                      <b-dropdown-item href="#"> Download </b-dropdown-item>
                      <b-dropdown-item href="#"> Delete </b-dropdown-item>
                    </b-dropdown>
                  </b-card-header>

                  <!-- body -->
                  <b-card-body>
                    <b-row class="justify-content-center align-items-center">
                      <b-col
                        md="6"
                        class="d-flex flex-column justify-content-center align-items-center text-center"
                      >
                        <feather-icon icon="FolderIcon" size="50" />
                        <b-card-text>document1.pdf</b-card-text>
                      </b-col>
                    </b-row>
                  </b-card-body>
                  <!--/ body -->
                </b-card>
              </b-col>
              <b-col md="3">
                <b-card class="custom-card mb-5">
                  <b-card-header class="justify-content-end px-0">
                    <b-dropdown
                      variant="link"
                      no-caret
                      class="chart-dropdown"
                      toggle-class="p-0"
                    >
                      <template #button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="18"
                          class="text-body cursor-pointer"
                        />
                      </template>
                      <b-dropdown-item v-b-modal.modal-document>
                        View
                      </b-dropdown-item>
                      <b-dropdown-item href="#"> Download </b-dropdown-item>
                      <b-dropdown-item href="#"> Delete </b-dropdown-item>
                    </b-dropdown>
                    <b-modal
                      id="modal-document"
                      ok-only
                      ok-title="Document"
                      centered
                      size="lg"
                      title="Document"
                      :hide-footer="true"
                    >
                      <ViewDocument @refresh="refreshData" />
                    </b-modal>
                  </b-card-header>

                  <!-- body -->
                  <b-card-body>
                    <b-row class="justify-content-center align-items-center">
                      <b-col
                        md="6"
                        class="d-flex flex-column justify-content-center align-items-center text-center"
                      >
                        <feather-icon icon="FolderIcon" size="50" />
                        <b-card-text>document2.pdf</b-card-text>
                      </b-col>
                    </b-row>
                  </b-card-body>
                  <!--/ body -->
                </b-card>
              </b-col>
            </b-row>

            <b-button
              size="sm"
              variant="outline-secondary"
              @click="row.toggleDetails"
            >
              Hide Details
            </b-button>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BContainer,
  BTabs,
  BTab,
  BFormCheckbox,
  BFormFile,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import ViewDocument from "./ViewDocument.vue";
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BContainer,
    BTabs,
    BTab,
    BFormCheckbox,
    BFormFile,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BDropdown,
    BDropdownItem,
    ViewDocument,
  },
  data() {
    return {
      newStatus: 0,
      start: null,
      apiError: false,
      additionalCost: 0,
      fields: ["operation_name", "view_document"],
      items: [
        {
          operation_name: "Operation Name 1",
        },
        {
          operation_name: "Operation Name 2",
        },
      ],
    };
  },
  methods: {
    openFilePicker() {
      // Trigger click event of the hidden file input
      this.$refs.fileInput.$el.querySelector("input").click();
    },
    handleFileUpload(event) {
      // Handle file upload here
      console.log("Uploaded files:", event.target.files);
      // You can perform further processing here as needed
    },
  },
};
</script>
